module.exports = __webpack_public_path__ + "static/media/paperFlowers.ab2157d4.jpg";